module.exports = __webpack_public_path__ + "h5/img/logo.08b295a3.png";